import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getRevenueProjection, RevenueProjectionResponse } from "@/services/adminApi";
import { Euro } from "lucide-react";

export function MrrCard() {
  const navigate = useNavigate();
  const [data, setData] = useState<RevenueProjectionResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await getRevenueProjection(navigate);
        setData(res);
      } catch (e) {
        setError(e instanceof Error ? e.message : "Erreur inconnue");
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">MRR</CardTitle>
        <Euro className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading && <div className="text-sm text-muted-foreground">Chargement...</div>}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {!loading && !error && (
          <>
            <div className="text-2xl font-bold">{data?.mrr?.toFixed(0)} &euro; / mois</div>
            <div className="text-xs text-muted-foreground">MRR B2C</div>
            <div className="flex gap-2 mt-1 text-xs text-muted-foreground">
              {Object.entries(data?.counts || {}).map(([k, v]) => (
                <span key={k}>
                  {v} <span className="uppercase">{k}</span>
                </span>
              ))}
            </div>
            {data?.b2b && (
              <div className="mt-2 border-t pt-2 text-xs text-muted-foreground">
                MRR B2B&nbsp;:{" "}
                <span className="font-medium text-foreground">
                  {data.b2b.mrr_eur.toFixed(0)} &euro; / mois
                </span>{" "}
                · {data.b2b.per_seat_orgs} org{data.b2b.per_seat_orgs > 1 ? "s" : ""} per-seat
              </div>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
